import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Grid,
  GridColumn as Column,
  GridNoRecords,
} from "@progress/kendo-react-grid";
import "@progress/kendo-theme-material/dist/all.css";
import i18next, { t } from "i18next";
import { useTranslation } from "react-i18next";

import { debounce } from "lodash";

import DoneIcon from "@mui/icons-material/Done";
import ClearIcon from "@mui/icons-material/Clear";
import { Stack, Button, Typography } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import ConfirmDialog from "../../components/ConfirmDialog";
import { enqueueSnackbar, useSnackbar } from "notistack";
import { ComponentType, DocumentStatus } from "../../common/enum";
import {
  getDocuments,
  setConfirmationDocumentDialog,
  setDocumentLimit,
  setDocumentOffset,
  setInvalidDocument,
  getDocumentsLinks
  } from "./slice";
import { addEntityDocuments } from "../OnBoarding/slice";
import { setConfirmationDialog } from "../AdminView/adminSlice";
const StatusCell = (props) => {
  const { translate } = useSelector((state) => state);
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  React.useEffect(() => {
    i18next.changeLanguage(translate);
  }, [translate]);

  return <td>{t(`${props.dataItem.status}`)}</td>;
};

const ExpiryCell = (props) => {
  const { translate } = useSelector((state) => state);
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  React.useEffect(() => {
    i18next.changeLanguage(translate);
  }, [translate]);

  return (
    
    // return formattedDate;
    <td>{
      new Date(
        props.dataItem.expiryDate
      ).toLocaleString("pt", {
        day: "numeric",
        month: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
        formatMatcher: "best fit",
      })
      // new Date(props.dataItem.expiryDate).toLocaleDateString("pt-PT")
      }</td>
  );
};

const FileTypeCell = (props) => {
  const { translate } = useSelector((state) => state);
  const { t } = useTranslation();

  React.useEffect(() => {
    i18next.changeLanguage(translate);
  }, [translate]);

  return <td>{t(`${props.dataItem.fileType}`)}</td>;
};

const DocumentNameCell = (props) => {
  const { translate } = useSelector((state) => state);
  const { t } = useTranslation();
  const dispatch = useDispatch();


  React.useEffect(() => {
    i18next.changeLanguage(translate);
  }, [translate]);

  const handleFileClick = async (e, fileName) => {
    e.preventDefault();
    try {
      const res = await dispatch(getDocumentsLinks(fileName)).unwrap();
      console.log("URL", res);
      
      const base64Data = res.isActive;
      const decodedData = atob(base64Data); // Decode the base64 string
  
      // Create a Blob from the decoded data
      const byteArray = new Uint8Array(decodedData.length);
      for (let i = 0; i < decodedData.length; i++) {
        byteArray[i] = decodedData.charCodeAt(i);
      }
  
      // Create a Blob and generate a URL
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
  
      // Open the URL in the browser
      window.open(url, "_blank");  // This opens the document in a new tab
    } catch (error) {
      console.error(error);
    }
  };
  
  return (
    // <td>
    //   {" "}
    //   <a
    //     href={props.dataItem.fileName ? props.dataItem.fileName : "#"}
    //     target="_blank"
    //     style={{ color: "blue", textDecoration: "underline" }}
    //   >
    //     {t("viewDocument")}{" "}
    //   </a>
    // </td>^
    <td>
      <a
        href="#"
        onClick={(e) => handleFileClick(e, props.dataItem.fileName)}
        style={{ color: "blue", textDecoration: "underline" }}
      >
        {t("viewDocument")}
      </a>
  </td>
  );
};


const ActionCell = (props) => {
  const dispatch = useDispatch();

  const {
    auth: {
      profile: { entity },
    },
    documentDetails: { documentOffset, documentLimit },
  } = useSelector((state) => state);

  const onApproved = React.useCallback(() => {
    const payload = {
      id: props.dataItem.id,
      loggedInUserId: props.dataItem.loggedInUserId,
      entityId: props.dataItem.entityId,
      uploadedDate: props.dataItem.uploadedDate,
      expiryDate: props.dataItem.expiryDate,
      updatedBy: entity.entityId,
      status: 'VALID',
      fileType: props.dataItem.fileType,
      fileName: props.dataItem.fileName,
    };
    dispatch(addEntityDocuments(payload))
      .unwrap()
      .then((res) => {
        let data = {
          limit: documentLimit,
          offset: documentOffset,
          entityId: props.dataItem.entityId,
        };
        dispatch(getDocuments(data));
        enqueueSnackbar({
          message: t("documentValidSuccessfully"),
          variant: "success",
          autoHideDuration: 3000,
        });
      })
      .catch((error) => {
        enqueueSnackbar({
          message: t("somethingWentWrong"),
          variant: "error",
          autoHideDuration: 3000,
        });
      });
  }, []);
  //documentRejectedSuccessfully
  const onRejectedHandle = React.useCallback(() => {
    const payload = {
      id: props.dataItem.id,
      loggedInUserId: props.dataItem.loggedInUserId,
      entityId: props.dataItem.entityId,
      uploadedDate: props.dataItem.uploadedDate,
      expiryDate: props.dataItem.expiryDate,
      updatedBy: entity.entityId,
      status: "INVALID",
      fileType: props.dataItem.fileType,
      fileName: props.dataItem.fileName,
    };
    dispatch(setInvalidDocument(payload));
    dispatch(setConfirmationDocumentDialog(true));
  }, [dispatch]);

  return (
    <td>
      <Stack
        direction={"row"}
        mt="10px"
        alignItems="center"
        spacing={1}
        width={1}
        justifyContent={"space-around"}
      >
        {(props.dataItem.status === DocumentStatus.invalid ||
          props.dataItem.status === DocumentStatus.waitingForValidation) && (
          <Tooltip title={t(`${DocumentStatus.valid}`)} arrow>
            <Button sx={{ p: 1, minWidth: 0 }} onClick={onApproved}>
              <DoneIcon fontSize="small" />
            </Button>
          </Tooltip>
        )}
        {(props.dataItem.status === DocumentStatus.waitingForValidation ||
          props.dataItem.status === DocumentStatus.valid) && (
          <Tooltip title={t(`${DocumentStatus.invalid}`)} arrow>
            <Button
              sx={{ p: 1, minWidth: 0, ml: 2 }}
              onClick={onRejectedHandle}
            >
              <ClearIcon fontSize="small" />
            </Button>
          </Tooltip>
        )}
      </Stack>
    </td>
  );
};
//componentType === ComponentType.ADMIN_VIEW ? true : false
const DocumentDetails = ({ componentType, entityId, t }) => {
  const [columns, setColumns] = React.useState([
    {
      field: "fileType",
      title: "documentType",
      width: "200px",
      cell: FileTypeCell,
      show: true,
    },
    {
      field: "fileName",
      title: "documentName",
      width: "200px",
      cell: DocumentNameCell,
      show: true,
    },
    {
      field: "status",
      title: "status",
      width: "200px",
      cell: StatusCell,
      show: true,
    },
    {
      field: "expiryDate",
      title: "expiryDate",
      width: "200px",
      cell: ExpiryCell,
      show: true,
    },
    {
      field: "",
      title: "Ações",
      width: "120px",
      cell: ActionCell,
      show: componentType === ComponentType.ADMIN_VIEW ? true : false,
    },
  ]);
  const dispatch = useDispatch();
  const {
    auth: {
      profile: { entity },
    },
    documentDetails: {
      documents,
      documentCount,
      documentOffset,
      documentLimit,
      invalidDocument,
      confirmationDocumentDialog,
    },
  } = useSelector((state) => state);setInvalidDocument
  const { enqueueSnackbar } = useSnackbar();
  const timer = React.useRef(null);
  const [dataState, setDataState] = React.useState({
    take: 20,
    skip: 0,
  });

  const handleClose = React.useCallback(() => {
    dispatch(setConfirmationDocumentDialog(false));
  }, [dispatch]);

  const onConfirm = () => {
    
    dispatch(addEntityDocuments(invalidDocument))
      .unwrap()
      .then((res) => {
        let data = {
          limit: documentLimit,
          offset: documentOffset,
          entityId: invalidDocument.entityId,
        };
        dispatch(getDocuments(data));
        dispatch(setConfirmationDocumentDialog(false));
        enqueueSnackbar({
          message: t("documentRejectedSuccessfully"),
          variant: "success",
          autoHideDuration: 3000,
        });
      })
      .catch((error) => {
        enqueueSnackbar({
          message: t("somethingWentWrong"),
          variant: "error",
          autoHideDuration: 3000,
        });
      });
  };

  const debouncedApiCall = debounce(async (value) => {
    const limit = value.skip + value.take;
    const offset = value.skip;
    let data = {
      limit: limit,
      offset: offset,
      entityId: entityId,
    };
    dispatch(getDocuments(data));
    dispatch(setDocumentLimit(limit));
    dispatch(setDocumentOffset(offset));
  }, 1000);

  const dataStateChange = (e) => {
    const value = e.dataState;
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      debouncedApiCall(value);
    }, 1000);
    setDataState(e.dataState);
  };
  
  return (
    <React.Fragment>
      <React.Fragment>
        <Grid
          data={documents}
          resizable={true}
          // skip={page.skip}
          // take={page.take}
          total={documentCount}
          pageable={true}
          {...dataState}
          // onPageChange={pageChange}
          onDataStateChange={dataStateChange}
          // groupable={true}
        >
          <GridNoRecords>{t("noRecordAvailable")}</GridNoRecords>
          {columns.map(
            (column) =>
              column.show && (
                <Column
                  key={column.title}
                  field={column.field}
                  title={t(`${column.title}`)}
                  cell={column.cell}
                />
              )
          )}
        </Grid>
        <ConfirmDialog
          open={confirmationDocumentDialog}
          handleClose={handleClose}
          title={t("")}
          content={t("confirmInvalidDocument")}
          onConfirm={onConfirm}
          cancelButtonTitle={t("cancel")}
          confirmButtonTitle={t("confirm")}
        />
      </React.Fragment>
    </React.Fragment>
  );
};

export default DocumentDetails;
